import { JobApplicationContainer } from "@container/job-application"
import AuthLayout from "@container/layout/auth";

export default function JobSeekerMyJob() {
    return (
        <AuthLayout>
            <JobApplicationContainer />
        </AuthLayout>
    );
}
